// iPhones before iOS 15.4 lack Object.hasOwn; the statistics charts (recharts / es-toolkit) call it
if (!Object.hasOwn) {
  Object.defineProperty(Object, "hasOwn", {
    value: (object, key) => Object.prototype.hasOwnProperty.call(object, key),
    configurable: true,
    writable: true,
  });
}
